// export const SetAppointment = () => {
//     return (
//         <div>
//             SetAppointment
//         </div>
//     );

// }

import React, { useEffect, useLayoutEffect } from 'react';
import { FormHelperText, Typography } from '@mui/material';
import { SetAppointmentRoot, StyledListItemText, GridContainer, GridTile, GridDescription, StyledPrimaryTittleWrapper } from './styles'
import { BoxPanel, TitleStyle } from '../styles';
import { connect, useDispatch } from 'react-redux';
import { defaultStepPropertyTypeListEnum, defaultSubStepPropertyTypeEnum, journeyTypes, setAppointmentWidgets } from 'assets/constants';
import { Loader, StepCustomWidgets, Success } from 'components';
import { dateLanguageFormat, findProperty, isBoolean, replaceSubstrings, separateWidgetsAndProperties, timeLanguageFormat, toTime } from 'utils';
import { useBookAppointment } from './hooks';
import { IconCustomerInfo, IconDateAndTime, IconLocation, IconService, IconServiceType, IconAppointmentType } from 'assets/icons';
import { useAnalyticsEventPageView, useBackToFirstStep } from 'screens/hooks';
import { stepsIndicatorsArrayToObject } from 'utils';
import { activeStepSet, scriptMessagesSet, nextStepSet } from 'store/steps';
import { popupActiveSet } from 'store/general';
import { useOnlineBookingApi } from 'shell';
import { userDataSet } from 'store/userData';
import { extractQuestions } from 'utils/src/extractQuestions';
import { CustomMessage } from 'components/core';

const { setAppointment: setAppointmentKey } = defaultStepPropertyTypeListEnum;

// Extract default sub-step types for success and cancel appointments
const { stepSuccess, stepSuccessReschedule, stepCancelAppointment, stepCancelAppointmentReschedule, stepCancelAppointmentReschedule1, stepSuccessQuickReschedule } = defaultSubStepPropertyTypeEnum;

const stepSuccessObj = stepsIndicatorsArrayToObject([stepSuccess, stepSuccessReschedule, stepSuccessQuickReschedule])
const stepCancelAppointmentObj = stepsIndicatorsArrayToObject([stepCancelAppointment, stepCancelAppointmentReschedule, stepCancelAppointmentReschedule1, defaultSubStepPropertyTypeEnum.stepCancelAppointmentQuickReschedule])


// SetAppointment component
const SetAppointment = ({ lngCode, step, nextStepSet, activeStepSet, userData, userDataSet, successStepActive, scriptMessages, setAppointmentData, setNavigateNext, popupActiveSet, popupState, isPreview, dateAndTimeStepPosition, journeyTypeId, ...props }) => {
  useAnalyticsEventPageView("Set Appoitment")

  const api = useOnlineBookingApi();
  const backToFirstStep = useBackToFirstStep();
  const { properties: { properties }, subStepList } = step;

  // Separate the widgets and main properties
  const [widgetsBefore, allMainProperties, widgetsAfter] = separateWidgetsAndProperties(properties);

  // Extract the setAppointmentProperty from allMainProperties
  const setAppointmentProperty = findProperty(allMainProperties, setAppointmentKey);
  const { hasRecaptcha, warningText, buttonAnotherSlot } = setAppointmentProperty;

  const { serviceType, appointmentType, service, customerGUID, clientStateData, journeyGUID, location } = userData || {}; 
  const questionAnswerDict = extractQuestions(userData)
  const onSucessSumInfo = (data) => {
    userDataSet({
      serviceType: { ...serviceType, name: data.serviceTypeName },
      appointmentType: { ...appointmentType, name: data.appointmentTypeName },
      service: { ...service, name: data.serviceName },
      location: { ...location, name: data.locationName || userData?.location?.name },
    });
  }
  const { data: appointmentDetails } = api.appointment.useAppointmentDetailsQuery(
    hasRecaptcha,
    clientStateData?.customerGUID || customerGUID,
    clientStateData?.journeyGUID || journeyGUID,
    clientStateData?.serviceTypeId || serviceType?.id,
    clientStateData?.unitId || location?.id,
    clientStateData?.appointmentTypeId || appointmentType?.id,
    clientStateData?.serviceId || service?.id,
    clientStateData?.calendarIds,
    clientStateData?.selectedSlot,
    clientStateData?.selectedDate,
    questionAnswerDict,
    { skip: !journeyTypeId || journeyTypeId !== journeyTypes.quickReschedule },
  );

  const { isLoading } = api.appointment.useAppointmentSumInfoQuery(
    clientStateData?.serviceTypeId || serviceType?.id,
    clientStateData?.appointmentTypeId || appointmentType?.id,
    clientStateData?.serviceId || service?.id,
    onSucessSumInfo,
  );
  const dispatch = useDispatch();
  const handleBookAppointment = useBookAppointment({
    hasRecaptcha,
    isPreview,
    userData,
    warningText,
    buttonAnotherSlot,
    dateAndTimeStepPosition,
    journeyTypeId
  });

  useEffect(() => {
    dispatch(scriptMessagesSet([]))
  }, []);


  useLayoutEffect(() => {
    setNavigateNext({ onNavigateNext: () => handleBookAppointment(), buttonSetAppointment: setAppointmentProperty?.buttonSetAppointment })
    return () => {
      setNavigateNext({ onNavigateNext: () => nextStepSet() })
    }
  }, [lngCode, handleBookAppointment])

  if (isLoading) return <Loader />;

  // Find the success and cancel appointment data from sub-step list
  const successPageData = subStepList?.find(({ type }) => stepSuccessObj[type]);
  const cancelAppointmentData = subStepList?.find(({ type }) => stepCancelAppointmentObj[type]);

  // Extract setAppointmentPage and successPage indicators
  const { setAppointmentPage, successPage } = setAppointmentWidgets;

  const widgetView = successStepActive ? successPage : setAppointmentPage;

  // if client not configured Success step go straight to login on success
  widgetView === successPage && !successPageData && backToFirstStep();

  const {
    title, additionalDescription,
    customerTitle, locationTitle, serviceTypeTitle, appointmentTypeTitle, serviceTitle, dateAndTimeTitle
  } = setAppointmentProperty;
  const stepTitleTranslation = {
    customerName: { title: customerTitle, icon: IconCustomerInfo },
    location: { title: locationTitle, icon: IconLocation },
    serviceType: { title: serviceTypeTitle, icon: IconServiceType },
    appointmentType: { title: appointmentTypeTitle, icon: IconAppointmentType },
    service: { title: serviceTitle, icon: IconService },
    dateAndTime: { title: dateAndTimeTitle, icon: IconDateAndTime },
    // details: detailsTitle
  };
  // Get the titles for display using the setAppointmentBoxOptions and userData
  const titles = Object.keys(userData)
    .filter((option) => !!stepTitleTranslation[option] && !isBoolean(userData[option]))
    .map(option => {
      const obj = {
        titleKey: `${option}_title`,
        valueKey: `${option}_value`,
        value: userData[option]?.name,
        stepKey: option
      }

      if (option === 'dateAndTime') {
        const { date, appointmentStartTime } = userData[option];
        const dateWithTime = `${date} ${toTime(parseInt(appointmentStartTime / 60), parseInt(appointmentStartTime % 60))}`;
        obj.value = `${dateLanguageFormat(lngCode, date)}, ${timeLanguageFormat(lngCode, dateWithTime)}`
      }

      return obj;
    });

  //replace key customerName in subtitle
  const renderSubTitle = () => replaceSubstrings(additionalDescription, { '{{customerName}}': userData?.customerName }, true);
  const renderSetAppointment = () => {
    return (
      <SetAppointmentRoot>
        <StepCustomWidgets widgets={widgetsBefore} />
        <TitleStyle>
          <Typography variant='h1'>
            {title}
          </Typography>
          <FormHelperText>
            {renderSubTitle()}
          </FormHelperText>
        </TitleStyle>
        <BoxPanel className="BoxShadow" >
          <GridContainer tabIndex={0}>
            {titles.map(({ stepKey, titleKey, value, valueKey }, index) => {
              const Icon = stepTitleTranslation[stepKey].icon;
              return (
                value && <React.Fragment key={index}>
                  <GridTile>
                    <StyledPrimaryTittleWrapper direction={'row'}>
                      <Icon />
                      <StyledListItemText
                        key={titleKey}
                        primary={stepTitleTranslation[stepKey].title}
                      />
                    </StyledPrimaryTittleWrapper>
                  </GridTile>
                  <GridDescription>
                    <StyledListItemText
                      key={valueKey}
                      secondary={value} />
                  </GridDescription>
                </React.Fragment>
              )
            })}
          </GridContainer>
        </BoxPanel>
        <StepCustomWidgets widgets={widgetsAfter} />
        {scriptMessages?.map(({ message, messageType }, index) => (<CustomMessage key={index} message={message} type={messageType} />))}      </SetAppointmentRoot>
    )
  }

  const renderSuccessPage = () => {

    return !!successPageData
      ? (
        <Success
          lngCode={lngCode}
          step={successPageData}
          cancelAppointmentData={cancelAppointmentData}
          handleBackToFirstStep={backToFirstStep}
          journeyTypeId={journeyTypeId} />
      )
      : null
  }
  const renderScreen = () => {
    switch (widgetView) {
      case setAppointmentPage:
        return renderSetAppointment()
      case successPage:
        return renderSuccessPage()
      default:
        return null
    }
  }

  return (
    <>
      {renderScreen()}
    </>
  );

}

export default connect(({
  current: { userData, steps: { successStepActive, scriptMessages }, general: { popupState, language: { lngCode } } } }) =>
  ({ userData, lngCode, popupState, successStepActive, scriptMessages }),
  { nextStepSet, activeStepSet, popupActiveSet, userDataSet })
  (SetAppointment);